import * as drawActions from "../actions/nav-draw.js"

const initialState = {
	isOpen: false
}

export default function(state = initialState, action){
	switch(action.type){
		case drawActions.OPEN_DRAWER:
			return Object.assign({}, state, {isOpen: true})

		case drawActions.CLOSE_DRAWER:
			return Object.assign({}, state, {isOpen: false})

		case drawActions.TOGGLE_DRAWER:
			return Object.assign({}, state, {isOpen: !state.isOpen})
	}

	return state
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/reducers/nav-draw.js